import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {TuiPdfViewerOptions, TuiPdfViewerService} from '@taiga-ui/kit';
import {PolymorpheusContent} from '@taiga-ui/polymorpheus';
import {BaseComponent, DamItem, DamItemVersion, InputFile} from 'compob2b-libs';
import {catchError, take, tap} from 'rxjs/operators';
import {DamService} from '../../../../../dam.service'

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

@Component({
  selector: 'app-dam-item-info-view',
  templateUrl: './dam-item-info-view.component.html',
  styleUrls: ['./dam-item-info-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DamItemInfoViewComponent extends BaseComponent {

  @Input() model: DamItem;
  @Input() write = false;
  @Input() damItem: DamItemVersion = null;
  @Output() reload: EventEmitter<void> = new EventEmitter();

  showUploader = false;

  constructor(protected readonly sanitizer: DomSanitizer,
              protected readonly damService: DamService,
              protected readonly pdfService: TuiPdfViewerService,
  ) {
    super();
  }

  /**
   * @description:
   * Embedded PDFs in mobile doesn't work,
   * so you can use third-party services
   * or your own service to render PDF in mobile iframe
   */
  show(actions: PolymorpheusContent<TuiPdfViewerOptions>, id: number): void {
    this.pdfService
      .open(
        this.sanitizer.bypassSecurityTrustResourceUrl(
          this.environment.serverUrl + '/dam/data/' + this.model.syncUid + '/' + id),
        {
          label: 'Dam document',
          actions,
        },
      )
      .subscribe();
  }

  onUpload(files: InputFile[]) {
    this.loading = true;
    this.compoApiService
      .postForm<DocumentFile, string>('/dam/upload-version/' + this.model.id, {enabled: true, header: files[0].file.name, fileInput: files[0].file})
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(response => {
          this.loading = false;

          const message = this.damService.getUploadError(response);
          if (message) {
            this.warningToast(message);
          } else {
            this.showUploader = false;
            this.reload.emit();
            this.cdr.detectChanges();
          }
        }),
      ).subscribe();
  }
}
